export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-08.7c423f40.jpg";